<app-dialog-banner text="Change {{availableWidget.name}}" [dialogRef]="dialogRef"></app-dialog-banner>
<div style="padding: 10px;">
    @if(availableWidget.chart?.options) {
        <div style ="display:flex; text-align: center">
            @for (option of availableWidget.chart.options; track option) {
                <button mat-button (click)="option.action()" color="primary">
                    {{option.name}}
                </button>
            }
        </div>
    }
    <div style="display:flex; flex-direction:column; gap: 10px">
        <div style="display:flex;">
            <div class="labelCell">Current Widget</div>
            <div class="valueCell">{{availableWidget.name}}</div>
        </div>
        <div style="display:flex;">
            <div class="labelCell">Change To</div>
            <div class="valueCell">
                <select  (change)="widgetSelected($any($event.target).value)">
                    <option></option>
                    @for (avail of availableWidgets; track avail.code) {
                        <option [value]="avail.code">{{ avail.name }}</option>
                    }
                </select>                
            </div>
        </div>
        <div style="display:flex;">
            <div style="width:130px; height:256px; display:flex; align-items:center; justify-content:center;">
                Widget Size {{chosenWidget.widthWeight}} X {{chosenWidget.heightWeight}}
            </div>
            <div 
                style="display: grid; width: 270px; margin-bottom: 20px; border-collapse: collapse;"
                (mouseleave)="resetSize()"
                [style.grid-template-columns]="'repeat(' + availableWidths.length + ', 1fr)'"
                [style.grid-template-rows]="'repeat(' + availableHeights.length + ', auto)'"
            >
            @for (iHeight of availableHeights; track iHeight) {
                @for (iWidth of availableWidths; track iWidth) {
                    <!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
                    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                    <div
                        (mouseenter)="showSize(iWidth, iHeight)"
                        (click)="setSize(iWidth, iHeight)"
                        [style.background-color]="iWidth <= chosenWidget.widthWeight && iHeight <= chosenWidget.heightWeight ? 'lightgrey' : 'white'"
                        style="
                        border: 1px dotted;
                        aspect-ratio: 1 / 1; /* keep cells square-ish if desired */
                        text-align: center;
                        vertical-align: middle;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        "
                    >
                        @if (iHeight === data.chosenWidget.heightWeight && iWidth === data.chosenWidget.widthWeight) {
                            {{ iWidth }}X{{ iHeight }}
                        } @else {
                            &nbsp;
                        }
                    </div>
                }
            }
            </div>
        </div>        
    </div>
    <div style="width: 100%; text-align: center;">
        <button mat-raised-button (click)="removeChart()" color="warn">Remove Widget</button>
    </div>
    
</div>